import img1 from '../assets/gallery/gallery1.jpg';
import img2 from '../assets/gallery/gallery2.jpg';
import img3 from '../assets/gallery/gallery3.jpg';
import img4 from '../assets/gallery/gallery4.jpg';
import img5 from '../assets/gallery/gallery5.jpg';
import img6 from '../assets/gallery/gallery6.jpg';
import img7 from '../assets/gallery/gallery7.jpg';
import img8 from '../assets/gallery/gallery8.jpg';
import img9 from '../assets/gallery/gallery9.jpg';
import img10 from '../assets/gallery/gallery10.jpg';
import img11 from '../assets/gallery/gallery11.jpg';
import img12 from '../assets/gallery/gallery12.jpg';
import img13 from '../assets/gallery/gallery13.jpg';
import img14 from '../assets/gallery/gallery14.jpg';
import img15 from '../assets/gallery/gallery15.jpg';
import img16 from '../assets/gallery/gallery16.jpg';
import img17 from '../assets/gallery/gallery17.jpg';
import img18 from '../assets/gallery/gallery18.jpg';
import img19 from '../assets/gallery/gallery19.jpg';
import img20 from '../assets/gallery/gallery20.jpg';
import img21 from '../assets/gallery/gallery21.jpg';
import img22 from '../assets/gallery/gallery22.jpg';





let gallery = [
    {
        imgUrl: img1,
        title: 'Modern Kitchen',
        description: 'A sleek and modern kitchen with stainless steel appliances and minimalist design.',
        category: 'Bathroom',
        featured: true
    },
    {
        imgUrl: img2,
        title: 'Cozy Bathroom',
        description: 'A cozy bathroom featuring a clawfoot tub and vintage fixtures.',
        category: 'Bathroom',
        featured: true
    },
    {
        imgUrl: img3,
        title: 'Elegant Fireplace',
        description: 'An elegant living room with a grand fireplace and classic decor.',
        category: 'Bathroom',
        featured: true
    },
    {
        imgUrl: img4,
        title: 'Outdoor Patio',
        description: 'A beautiful outdoor patio with comfortable seating and lush greenery.',
        category: 'Bathroom',
        featured: true
    },
    {
        imgUrl: img5,
        title: 'Modern Office Space',
        description: 'A modern office space with open layout and contemporary furniture.',
        category: 'Kitchen',
        featured: true
    },
    {
        imgUrl: img6,
        title: 'Rustic Kitchen',
        description: 'A rustic kitchen with wooden beams and farmhouse-style decor.',
        category: 'Kitchen',
        featured: false
    },
    {
        imgUrl: img7,
        title: 'Luxurious Bathroom',
        description: 'A luxurious bathroom with marble countertops and a spacious walk-in shower.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img8,
        title: 'Contemporary Fireplace',
        description: 'A contemporary living room with a sleek fireplace and modern furnishings.',
        category: 'Other',
        featured: false
    },
    {
        imgUrl: img9,
        title: 'Commercial Lobby',
        description: 'A commercial lobby with stylish seating and contemporary art pieces.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img10,
        title: 'Garden Patio',
        description: 'A serene garden patio with comfortable seating and beautiful landscaping.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img11,
        title: 'Minimalist Kitchen',
        description: 'A minimalist kitchen with clean lines and a monochromatic color scheme.',
        category: 'Kitchen',
        featured: false
    },
    {
        imgUrl: img12,
        title: 'Spa-like Bathroom',
        description: 'A spa-like bathroom with a soaking tub and natural stone accents.',
        category: 'Other',
        featured: false
    },
    {
        imgUrl: img13,
        title: 'Classic Fireplace',
        description: 'A classic living room with a traditional fireplace and elegant decor.',
        category: 'Other',
        featured: false
    },
    {
        imgUrl: img14,
        title: 'Rooftop Patio',
        description: 'A chic rooftop patio with panoramic city views and modern furnishings.',
        category: 'Kitchen',
        featured: false
    },
    {
        imgUrl: img15,
        title: 'Open Office Space',
        description: 'An open office space with collaborative work areas and modern design.',
        category: 'Other',
        featured: false
    },
    {
        imgUrl: img16,
        title: 'Vintage Kitchen',
        description: 'A vintage kitchen with retro appliances and colorful decor.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img17,
        title: 'Modern Bathroom',
        description: 'A modern bathroom with sleek fixtures and a minimalist design.',
        category: 'Other',
        featured: false
    },
    {
        imgUrl: img18,
        title: 'Rustic Fireplace',
        description: 'A rustic living room with a stone fireplace and cozy furnishings.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img19,
        title: 'Corporate Lobby',
        description: 'A corporate lobby with sleek design and modern art installations.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img20,
        title: 'Beachside Patio',
        description: 'A relaxing beachside patio with comfortable seating and ocean views.',
        category: 'Bathroom',
        featured: false
    },
    {
        imgUrl: img21,
        title: 'Modern Kitchen',
        description: 'A sleek and modern kitchen with stainless steel appliances and minimalist design.',
        category: 'Bathroom',
        featured: true

    },
    {
        imgUrl: img22,
        title: 'Cozy Bathroom',
        description: 'A cozy bathroom featuring a clawfoot tub and vintage fixtures.',
        category: 'Bathroom',
        featured: false
    }
    
];

export default gallery;